import React from 'react';

const Button = () => (
  <button type="button" className="btn btn-primary">
Button
  </button>
);
export default Button;
